<!-- /**
* 工队详情页面
* @authors zzt
* @date 2019/1/28
* @version 1.0
*/ -->
<template>
  <div class="talents-mess-box">
    <Breadcrumb :breadcrumbName="breadcrumbObj"></Breadcrumb>
    <div class="textCont_right">
      <el-row>
        <el-col :span="12">
          <P class="details_title">
            <span>{{ constructionTeamData.title }}</span>
            <span class="posiIcon" v-if="constructionTeamData.validate === 1">
              <img src="@/static/img/shiminzhenz.png" alt="" />
            </span>
          </P>
          <div class="details_version flex_jc_sb">
            <div class="company">
              <span>
                更新时间：{{
                  formatDate2(
                    constructionTeamData.currentTime,
                    constructionTeamData.refreshTime
                  )
                }}
              </span>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="details_phoneNumber">
            <img class="phoneImg" src="@/assets/details-logo/tel.png" />
            <div class="flex flex_jc_sb">
              <div class="contact_way">
                <div class="flex_jc_sb">
                  <span class="phone">{{
                    constructionTeamData.concatPhone
                  }}</span>
                  <span class="name">{{ constructionTeamData.concat }}</span>
                </div>
                <div class="flex_jc_sb">
                  <span class="phone">400-001-0051</span>
                  <span class="name">客服联系电话</span>
                </div>
                <p class="mesges">联系我时，请说明是在施工邦上面看到的喔!</p>
              </div>
              <div>
                <div
                  class="enter_the_store flex_jc_center flex_ai_center"
                  v-if="$store.state.loginType"
                  v-on:click="checkContactway"
                >
                  查看联系方式
                </div>
                <div
                  class="enter_the_store flex_jc_center flex_ai_center"
                  v-else
                  @click="loginIndex"
                >
                  查看联系方式
                </div>
                <!-- <div class="enter_the_store tenderBtn flex_jc_center flex_ai_center">进入店铺</div> -->
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--<div class="details">-->
    <!--<Title :title="title"></Title>-->
    <!--<Tab ref="tab" :rollScroll="rollScroll" @check="check" @changeRollScroll="changeRollScroll" :tab="tab"></Tab>-->
    <!--&lt;!&ndash;<div v-show="rollScroll">&ndash;&gt;-->
    <!--&lt;!&ndash;<div class="tc-50"></div>&ndash;&gt;-->
    <!--&lt;!&ndash;<div class="tc-20"></div>&ndash;&gt;-->
    <!--&lt;!&ndash;</div>&ndash;&gt;-->
    <!--&lt;!&ndash;<DetailsInner1 v-if="tab[0].show" ref="detailsInner1" @check="check" :DetailsData="constructionTeamData"></DetailsInner1>&ndash;&gt;-->
    <!--&lt;!&ndash;<DetailsInner2 v-if="tab[1].show" ref="detailsInner2" @check="check" :DetailsData="constructionTeamData"></DetailsInner2>&ndash;&gt;-->
    <!--&lt;!&ndash;<DetailsInner3 v-if="tab[2].show" ref="detailsInner3" @check="check" :DetailsData="constructionTeamData"></DetailsInner3>&ndash;&gt;-->
    <!--&lt;!&ndash;<DetailsInner4 v-if="tab[3].show" ref="detailsInner4" @check="check" :DetailsData="constructionTeamData"></DetailsInner4>&ndash;&gt;-->
    <!--</div>-->
    <!--<div class="tc-100"></div>-->
    <div>
      <div class="tab-box">
        <div class="inner">
          <div
            id="tab"
            v-for="(item, index) in tab"
            :key="index"
            :class="{ check: checkIndex == index }"
            class="cursor"
            @click="check(index)"
            v-show="item.show"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="details-inner-box details-inner-bottom" ref="detailsInner1">
      <div v-if="checkIndex == 0">
        <div class="detail">
          <div class="item-block">
            <div class="label">行业分类</div>
            <div class="info">
              <el-tag type="info" v-for="item in teamTypeData" :key="item.id">{{
                item.name
              }}</el-tag>
            </div>
          </div>
          <div class="item-block">
            <div class="label">主营业务</div>
            <div class="info">
              <el-tag type="info" v-for="item in teamSkillsData" :key="item.id">
                {{ item.name }}
              </el-tag>
            </div>
          </div>
          <div class="item-block">
            <div class="label">队伍规模</div>
            <div class="info">{{ constructionTeamData.scale || 0 }}人</div>
          </div>
          <div class="item-block" v-if="constructionTeamData.teamComposition">
            <div class="label">队伍组成</div>
            <div class="info">{{ constructionTeamData.teamComposition }}</div>
          </div>
          <div class="item-block">
            <div class="label">所在城市</div>
            <div class="info">{{ constructionTeamData.locationName }}</div>
          </div>
        </div>
      </div>
      <!--<div v-if="checkIndex == 1">-->
      <!--<div class="title" v-if="constructionTeamData.introduce">工队介绍</div>-->
      <!--</div>-->
      <div v-if="checkIndex == 1">
        <div class="p_info" v-if="constructionTeamData.introduce">
          <div class="p_content" v-html="constructionTeamData.introduce"></div>
          <!--<p class="target">-->
          <!--<span @click="targetOpen($event)">点击展开</span>-->
          <!--<i class="el-icon-caret-bottom" @click="targetOpen($event)"></i>-->
          <!--</p>-->
        </div>
        <div class="noData" v-else>
          <div class="noDataImg">
            <img src="@/static/img/cailiao.png" alt />
          </div>
          <p class="noText">暂无数据</p>
        </div>
      </div>
      <!--<div class="title" v-if="constructionTeamData.performance">业绩介绍</div>-->
      <div v-if="checkIndex == 2">
        <div class="p_info" v-if="constructionTeamData.performance">
          <div
            class="p_content"
            v-html="constructionTeamData.performance"
          ></div>
          <!--<p class="target">-->
          <!--<span @click="targetOpen($event)">点击展开</span>-->
          <!--<i class="el-icon-caret-bottom" @click="targetOpen($event)"></i>-->
          <!--</p>-->
        </div>
        <div class="noData" v-else>
          <div class="noDataImg">
            <img src="@/static/img/cailiao.png" alt />
          </div>
          <p class="noText">暂无数据</p>
        </div>
      </div>
      <!--<div class="title" v-if="constructionTeamData.equipment">设备介绍</div> ellipsis4-->
      <div v-if="checkIndex == 3">
        <div class="p_info" v-if="constructionTeamData.equipment">
          <div class="p_content" v-html="constructionTeamData.equipment"></div>
          <!--<p class="target">-->
          <!--<span @click="targetOpen($event)">点击展开</span>-->
          <!--<i class="el-icon-caret-bottom" @click="targetOpen($event)"></i>-->
          <!--</p>-->
        </div>
        <div class="noData" v-else>
          <div class="noDataImg">
            <img src="@/static/img/cailiao.png" alt />
          </div>
          <p class="noText">暂无数据</p>
        </div>
      </div>
      <!-- <div class="title">证书展示</div>
    <div class="p_img">
      <div class="imgs" v-for="(item,index) in DetailsData.talentSkillVOList" :key="index">
        <img v-lazy="item.certificate" alt="">
      </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import { apiTalentsMess } from "@/api/apiTalentsMess"
import link from "@/public/link.js"
import { formatDate2 } from "@/filters"
export default {
  name: "ConstructionDetails",
  props: {},
  data() {
    return {
      checkIndex: 0,
      phone: "",
      title: {
        name: "",
        updateTime: null
      },
      breadcrumbObj: {
        secondName: "优质工队",
        secondPath: "/construction",
        threeName: "优质工队详情"
      },
      tab: [
        {
          name: "工队详情",
          show: true
        },
        {
          name: "工队介绍",
          show: true
        },
        {
          name: "业绩介绍",
          show: true
        },
        // {
        //   name: '专业人才',
        //   show: true
        // },
        {
          name: "设备介绍",
          show: true
        }
      ],
      constructionTeamData: {},
      teamTypeData: [],
      teamSkillsData: [],
      rollScroll: false
    }
  },
  computed: {},
  components: {
    Breadcrumb: () => import("@/components/public/Breadcrumb")
  },
  watch: {},
  methods: {
    loginIndex() {
      let data = {
        callBack: function() {
          this.$store.dispatch("setUser")
          this.pushThis()
        }.bind(this)
      }
      this.$_login(data)
    },
    setLi1() {
      let str = this.constructionTeamData.introduce
      // let i = 1
      let arr = str.split("<li>")
      let str2 = ""
      for (let i = 0; i < arr.length; i++) {
        if (i === 0) {
          str2 = str2 + arr[i]
          continue
        }
        str2 = str2 + `<li><span>${i}、 </span>` + arr[i]
      }
      this.constructionTeamData.introduce = str2
    },
    setLi2() {
      let str = this.constructionTeamData.performance
      // let i = 1
      let arr = str.split("<li>")
      let str2 = ""
      for (let i = 0; i < arr.length; i++) {
        if (i === 0) {
          str2 = str2 + arr[i]
          continue
        }
        str2 = str2 + `<li><span>${i}、 </span>` + arr[i]
      }
      this.constructionTeamData.performance = str2
    },
    setLi3() {
      let str = this.constructionTeamData.equipment
      // let i = 1
      let arr = str.split("<li>")
      let str2 = ""
      for (let i = 0; i < arr.length; i++) {
        if (i === 0) {
          str2 = str2 + arr[i]
          continue
        }
        str2 = str2 + `<li><span>${i}、 </span>` + arr[i]
      }
      this.constructionTeamData.equipment = str2
    },
    formatDate2,
    computedP() {
      let infobox = document.getElementsByClassName("p_content")
      Array.from(infobox).forEach(element => {
        if (element.offsetHeight < 93) {
          element.nextSibling.style.display = "none"
        } else {
          element.style.height = "96px"
        }
      })
    },
    hasClass(_classList, _className) {
      if (_classList.indexOf(_className) !== -1) {
        return true
      } else {
        return false
      }
    },
    targetOpen(e) {
      const currentTarget = e.currentTarget
      const child = currentTarget.parentNode.children
      const parent = currentTarget.parentNode
      const previous = currentTarget.parentNode.previousSibling
      if (this.hasClass(previous.className, "ellipsis4")) {
        previous.classList.remove("ellipsis4")
        previous.style.height = "auto"
        child[0].innerHTML = "点击收起"
        child[1].classList.remove("el-icon-caret-bottom")
        child[1].classList.add("el-icon-caret-top")
        parent.classList.add("isopen")
      } else {
        previous.classList.add("ellipsis4")
        previous.style.height = "96px"
        child[0].innerHTML = "点击展开"
        child[1].classList.remove("el-icon-caret-top")
        child[1].classList.add("el-icon-caret-bottom")
        parent.classList.remove("isopen")
      }
    },
    tel(telNum) {
      if (telNum) {
        let ary = telNum.split("")
        ary.splice(3, 4, "****")
        return ary.join("")
      }
      return ""
    },
    checkContactway() {
      if (this.$store.state.loginType) {
        this.constructionTeamData.concatPhone = this.phone
      } else {
        link.login()
        //   this.$confirm('当前未登录, 是否跳转到登录页面?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(() => {
        //     window.location.href = process.env.VUE_APP_DOMAIN +'/login'
        //   })
      }
    },
    async iniData(id) {
      let getData = await apiTalentsMess.getTeamDetail(id)
      this.constructionTeamData = getData.data.data
      this.title.name = this.constructionTeamData.title
      this.title.updateTime = this.constructionTeamData.submitTime
      let typeData = await apiTalentsMess.getTeamType(id)
      this.teamTypeData = typeData.data.data.first
      this.teamSkillsData = typeData.data.data.second
      this.getShowTab()
      // this.$refs.tab.listener();

      this.phone = this.constructionTeamData.concatPhone
      this.constructionTeamData.concatPhone = this.tel(
        this.constructionTeamData.concatPhone
      )
    },
    check(index) {
      this.checkIndex = index
      // switch (index) {
      //   case 0:
      //     this.$refs.detailsInner1.toOffset()
      //     break
      //   case 1:
      //     this.$refs.detailsInner2.toOffset()
      //     break
      //   case 2:
      //     this.$refs.detailsInner3.toOffset()
      //     break
      //   case 3:
      //     this.$refs.detailsInner4.toOffset()
      //     break
      // }
    },
    changeRollScroll(bol) {
      this.rollScroll = bol
    },

    menu() {
      // let dom = document.documentElement.scrollTop + document.body.scrollTop;
      // let height1, height2, height3, height4;
      // if (this.tab[0].show) {
      //   height1 = this.$refs.detailsInner1.getHeight();
      // }
      // if (this.tab[1].show) {
      //   height2 = this.$refs.detailsInner2.getHeight();
      // }
      // if (this.tab[2].show) {
      //   height3 = this.$refs.detailsInner3.getHeight();
      // }
      // if (this.tab[3].show) {
      //   height4 = this.$refs.detailsInner4.getHeight();
      // }
      // if (dom >= height4 && height4) {
      //   this.$refs.tab.checkIndex = 3;
      // } else if (dom >= height3 && height3) {
      //   this.$refs.tab.checkIndex = 2;
      // } else if (dom >= height2 && height2) {
      //   this.$refs.tab.checkIndex = 1;
      // } else if (dom >= height1 && height1) {
      //   this.$refs.tab.checkIndex = 0;
      // }
    },
    getShowTab() {
      // if (this.constructionTeamData.performances.length === 0) {
      //   this.$set(this.tab[1], 'show', false)
      // }
      // if (this.constructionTeamData.talents.length === 0) {
      //   this.$set(this.tab[2], 'show', false)
      // }
      // if (!this.constructionTeamData.equipment) {
      //   this.$set(this.tab[3], 'show', false)
      // }
    }
  },
  created() {},
  async mounted() {
    await this.iniData(this.$route.params.id)
    window.addEventListener("scroll", this.menu)
  },
  destroyed() {
    window.removeEventListener("scroll", this.menu)
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";
// @media screen and (min-width: 1218px){
//     .details{
//         width: 1200px;
//     }
// }
// @media screen and (max-width:1217px){
//     .details{
//         width: 100%;
//     }
// }

// @media screen and (max-width:992px){
//     .details{
//         width: 992px;
//     }
// }
.bgdf {
  background: #dfe4ea;
}
.talents-mess-box {
  width: 100%;
  background: #f5f5f5;
  .details {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    border: 1px solid #e4e7ed;
  }
}
.textCont_right {
  width: 1200px;
  margin: 0 auto 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  padding: 0 10px;
  box-shadow: 0 2px 5px #e1e1e1;
  border-radius: 3px;
  border: 1px solid #e4e7ed;
  /*width: 666px;*/
  p.details_title {
    font-size: 24px;
    color: #000000;
    line-height: 32px;
    padding: 15px 0 15px 53px;
    position: relative;
    .posiIcon {
      display: block;
      padding: 0 !important;
      position: absolute;
      width: 42px;
      height: 50px;
      top: 0;
      left: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    i {
      font-size: 14px;
      color: #ff6600;
      font-style: normal;
    }
  }
  .submission_time {
    span {
      font-size: 14px;
    }
    > div span:first-of-type {
      color: #949494;
    }
    > div:first-of-type {
      margin-right: 15px;
    }
  }
  p.details_prices {
    font-size: 16px;
    padding: 20px 0;
    color: #ff4e02;
    font-weight: bolder;
    > span:first-of-type {
      font-size: 18px;
      margin-right: 10px;
    }
  }
  .details_version,
  .details_year {
    width: 100%;
    margin-bottom: 20px;
    span {
      font-size: 14px;
      color: #000000;
      line-height: 20px;
    }
    > div {
      padding-left: 53px;
      width: 50%;
    }
    /*> div{*/
    /*width: 50%;*/
    /*}*/
    > div span:first-of-type {
      color: #949494;
    }
    .date {
      span {
        color: #969696;
      }
    }
  }
  // .details_year {
  //     width: 400px ;
  // }
  .details_phoneNumber {
    width: auto;
    position: relative;
    padding: 15px 25px 15px 65px;
    box-sizing: border-box;
    /*background: #faf6f3;*/
    /*border: 1px solid #e5e9ee;*/
    border-radius: 10px;
    .phoneImg {
      position: absolute;
      top: 50%;
      left: 20px;
      transform: translateY(-50%);
    }
    .contact_way {
      width: 60%;
      padding-left: 10px;
      > div {
        margin-bottom: 10px;
      }
      span.phone {
        width: 50%;
        font-size: 18px;
        color: #ff6600;
        font-weight: bolder;
      }
      span.name {
        width: 50%;
        font-size: 16px;
        color: #666666;
      }
      p.mesges {
        font-size: 12px;
        color: #969696;
      }
    }
    .enter_the_store {
      width: 120px;
      height: 40px;
      background: #f7ab01;
      font-size: 14px;
      color: #ffffff;
      border-radius: 5px;
      cursor: pointer;
    }
    .tenderBtn {
      background: #0286df;
      margin-top: 10px;
    }
    .bg-gray {
      background-color: #c0c4cc !important;
      cursor: default;
    }
  }
}
.details-inner-box {
  width: 1200px;
  margin: 0 auto 50px;
  box-sizing: border-box;
  background-color: white;
  padding: 10px 21px;
  /*border: 1px solid #e4e7ed;*/
  box-shadow: 3px 3px 10px rgba($color: #000000, $alpha: 0.08);
  border-radius: 0 0 4px 4px;
  .title {
    color: #0286df;
    font-size: 18px;
    line-height: 44px;
    font-weight: 400;
    border-bottom: 2px dotted #e4e7ed;
    position: relative;
    padding-left: 10px;
    &::before {
      content: "";
      position: absolute;
      top: 12px;
      left: 0;
      bottom: 12px;
      width: 3px;
      background-color: #409ee9;
    }
  }
  .detail {
    border: 1px solid #e4e7ed;
    margin: 20px 0;
    line-height: 54px;
    color: #666;
    font-size: 14px;
    .item-line {
      display: flex;
      border-bottom: 1px solid #e4e7ed;
      .item {
        display: flex;
        width: 25%;
      }
      .item-50 {
        display: flex;
        flex: 1;
      }
    }
    .item-block {
      display: flex;
      border-bottom: 1px solid #e4e7ed;
      &:last-child {
        border-bottom: none;
      }
    }
    .label {
      padding-left: 20px;
      width: 180px;
      background-color: #f5f7fa;
      border-right: 1px solid #e4e7ed;
    }
    .info {
      // padding-left: 10px;
      flex: 1;
      padding: 7px 20px;
      line-height: 40px;
      .el-tag {
        margin-right: 20px;
        background-color: #f5f7fa;
        font-size: 14px;
        color: #666;
      }
    }
  }
  .p_info {
    color: #666;
    font-size: 14px;
    .p_content {
      line-height: 24px;
      margin: 19px 0;
    }
    .target {
      cursor: pointer;
      color: #0286df;
      margin-bottom: 16px;
    }
    .isopen {
      color: #ff6600;
    }
  }
  .p_img {
    padding: 20px 0 0;
    clear: both;
    overflow: hidden;
    .imgs {
      float: left;
      width: 214px;
      height: 133px;
      margin-right: 21px;
      margin-bottom: 20px;
      &:nth-child(5n + 5) {
        margin-right: 0;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .ellipsis4 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
  }
}
.tab-box {
  width: 1200px;
  background: #f5f7fa;
  margin: 0 auto;
  .inner {
    border-bottom: 1px solid #e4e7ed;
    > div {
      display: inline-block;
      width: 105px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 16px;
    }
    .check {
      background: #fff;
      color: $default;
      position: relative;
      &::before {
        content: "";
        display: block;
        position: absolute;
        top: -1px;
        left: 0;
        width: 100%;
        border-top: 2px solid $default;
      }
      &::after {
        content: "";
        display: block;
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 100%;
        border-top: 1px solid #fff;
      }
    }
  }
}
.noData {
  width: 100%;
  margin-bottom: 50px;
  background: #ffffff;
  padding-bottom: 40px;
  padding-top: 50px;
  border-radius: 0 0 4px 4px;
  border-top: none;
  box-sizing: border-box;
  .noDataImg {
    width: 177px;
    margin: 0 auto 15px;
    img {
      width: 100%;
    }
  }
  .noText {
    text-align: center;
    font-size: 18px;
    color: #333;
  }
}
</style>
